// ** Reducers Imports
import layout from './layout'
import navbar from './navbar'
import auth from './authentication'
import calendar from '@src/views/calendar/store'
import users from '@src/views/users/store'
import profiles from '@src/views/profile/store'
import services from '@src/views/addServiceSteps/store'
import reportSchedule from '@src/views/reportSchedule/store'
import menus from '@src/views/menu/store'
import typeOfExams from '@src/views/typeOfExam/store'
import typeActivity from '@src/views/typeActivity/store'
import activity from '@src/views/activity/store'
import protocol from '@src/views/protocol/store'
import call from '@src/views/call/store'
import campaign from '@src/views/campaign/store'
import contact from '@src/views/contact/store'
import reportCall from '@src/views/reportCall/store'
import reportFinance from '@src/views/reportFinance/store'
import categories from '@src/views/category/store'
import providers from '@src/views/provider/store'
import companies from '@src/views/company/store'
import warehouses from '@src/views/warehouse/store'
import products from '@src/views/product/store'
import batches from '@src/views/batch/store'
import movements from '@src/views/movement/store'
import requests from '@src/views/request/store'
import requestManagements from '@src/views/requestManagement/store'
import configInventories from '@src/views/configInventory/store'
import presentations from '@src/views/presentation/store'
import stocks from '@src/views/stock/store'

const rootReducer = {
    navbar, 
    layout,
    auth,
    calendar,
    users,
    profiles,
    services,
    reportSchedule,
    menus,
    typeOfExams,
    typeActivity,
    activity,
    protocol,
    call,
    campaign,
    contact,
    reportCall,
    reportFinance,
    categories,
    providers,
    companies,
    warehouses,
    products,
    batches,
    movements,
    requests,
    requestManagements,
    configInventories,
    presentations,
    stocks
}

export default rootReducer
